import { Component, OnInit, Input, ViewChild } from '@angular/core'
import { Store } from '@ngrx/store'
import { BdcContentV2Service, BdcProductResponse } from '@tokeet-frontend/channel-content'
import { ActionFailed, isEmptyTable, isSomething, localeCompareSort, Toaster } from '@tokeet-frontend/tv3-platform'
import { filter, finalize, take } from 'rxjs/operators'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { BdcPropertyProductDialogService } from '../../bdc-property-product-dialog/bdc-property-product-dialog.service'

@Component({
  selector: 'app-bdc-property-products',
  templateUrl: './bdc-property-products.component.html',
  styleUrls: ['./bdc-property-products.component.scss'],
})
export class BdcPropertyProductsComponent implements OnInit {
  @Input() propertyId: number

  @ViewChild('paginator', { static: true }) paginator: MatPaginator
  @ViewChild(MatSort, { static: true }) sort: MatSort

  dataSource = new MatTableDataSource<BdcProductResponse>([])
  displayedColumns = ['propertyName', 'roomName', 'rateName', 'edit']
  isEmptyTable$ = isEmptyTable(this.dataSource)

  products: BdcProductResponse[] = []
  isLoading = false
  constructor(
    private store: Store<any>,
    private toaster: Toaster,
    private contentService: BdcContentV2Service,
    private bdcProductDialog: BdcPropertyProductDialogService
  ) {}
  ngOnInit(): void {
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
    this.dataSource.sortData = localeCompareSort

    this.onRefresh()
  }

  onRemove(product: BdcProductResponse) {
    this.contentService.deletePropertyProduct(product.propertyId, product.roomId, product.rateId).subscribe(
      () => {
        this.toaster.success($localize`Product deleted successfully.`)
        this.onRefresh()
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  onRefresh() {
    this.isLoading = true
    this.contentService
      .getPropertyProducts(this.propertyId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (products) => {
          this.products = products
          this.dataSource.data = products
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  onSearch(term: string) {
    this.dataSource.filter = (term + '').trim().toLowerCase()
  }

  onAdd() {
    this.bdcProductDialog
      .open({ propertyId: this.propertyId })
      .afterClosed()
      .pipe(filter(isSomething))
      .subscribe(() => {
        this.onRefresh()
      })
  }

  onEdit(product: BdcProductResponse) {
    this.bdcProductDialog
      .open({ propertyId: this.propertyId, product })
      .afterClosed()
      .pipe(filter(isSomething))
      .subscribe(() => {
        this.onRefresh()
      })
  }
}
